<div
  class="relative flex cursor-help items-start gap-1"
  style="justify-content: inherit;"
  ngxTippy
  tippyClassName="tippy-white"
  [tippyProps]="{
    allowHTML: true,
    placement: 'top',
    content: description | translate,
    maxWidth: 500
  }"
>
  <span class="label-text line-clamp-2" [innerHTML]="label | translate"></span>
  <!-- <svg-icon class="label-description-icon shrink-0" key="qmarkGrey" fontSize="14px">
  </svg-icon> -->
</div>
<!-- <popper-content #descriptionContent>
  <div class="description-content" [innerHTML]="description | translate"></div>
</popper-content> -->
